import {
    GET_PRESUPUESTO_DETALLE, GET_NEW_PRESUPUESTO_DETALLE, UPDATE_PRESUPUESTO_DETALLE
} from '../constants/action_types';

const initialState = { presupuesto: {}, isLoading: false, reload: false };

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_PRESUPUESTO_DETALLE:

            return { presupuesto: {}, isLoading: true, reload: false };

        case GET_PRESUPUESTO_DETALLE + "_SUCCESS":

            return { presupuesto: action.payload.data, isLoading: false, reload: false };

        case GET_NEW_PRESUPUESTO_DETALLE:

            return { ...state, isLoading: true }

        case GET_NEW_PRESUPUESTO_DETALLE + "_SUCCESS":

            return { presupuesto: { ...state.presupuesto, values: action.payload.data }, isLoading: false, reload: false };

        case UPDATE_PRESUPUESTO_DETALLE + "_SUCCESS":

            return { presupuesto: {}, isLoading: false, reload: true };

        default:

            return state;
    }

}